import React from "react";
import style from "./dressingAppearance.module.scss";
import { dressingAppearance, signedLockedAccess } from "../../../../utils";
import { Button, Form, SelectBox } from "../../../primary";
import { CANCEL_BTN, SAVE_BTN } from "../../../../constants";

export const DressingAppearanceEditMode = ({
  assessmentDetails,
  setFormChangesConfirm,
  handleSubmit,
  doSubmit,
  listResp,
  resp,
  register,
  onCancelClick,
  hideButtons,
}) => (
  <div>
    {signedLockedAccess(assessmentDetails?.assessmentStage) ? (
      <Form setFormChangesConfirm={setFormChangesConfirm} onSubmit={handleSubmit(doSubmit)}>
        <SelectBox
          id="dressinghStatus"
          name="dressinghStatus"
          label="Dressing Appearance:"
          classes={{
            column: `row ${style.col_spec}`,
            inputClassName: style.basic_select,
            labelClassName: "col-5",
            inputColumn: `col-6 p-0 ${style.select_wrapper}`,
          }}
          optionValue={listResp}
          defaultValue={resp?.dressingAppearance ?? ""}
          validator={register()}
          placeholder="Select"
        />

        {hideButtons && (
          <div className="row">
            <div className="mt-4 pt-2 col-sm-12 p-0">
              <div className="offset-5 p-0">
                <Button type="submit" classes={{ className: `btn ${style.btn_save}` }} id="updateBtn" value={SAVE_BTN} />
                <Button classes={{ className: `btn ${style.btn_cancel}` }} type="button" id="cancel" value={CANCEL_BTN} onClick={onCancelClick} />
              </div>
            </div>
          </div>
        )}
      </Form>
    ) : (
      "This wound assessment is signed and locked, cannot be updated."
    )}
  </div>
);
